const LocaleConfig = {
    "AllRight": "[Được rồi]",
    "Ambulance": "[Xe cứu thương]",
    "Angle": "[Thiên thần]",
    "Angry": "[Tức giận]",
    "Applause": "[Vỗ tay]",
    "Awkward": "[Xấu hổ]",
    "Beckoning": "[Nhịp tim]",
    "Bomb": "[Quả bom]",
    "Broken": "[Trái tim tan vỡ]",
    "Bye": "[Tạm biệt]",
    "Cloud": "[Đám mây]",
    "Cool": "[Tuyệt]",
    "Cry": "[khóc]",
    "Cute": "[Dễ thương]",
    "Despise": "[khinh bỉ]",
    "Disdain": "[khinh thường]",
    "Ecstasy": "[Ecstasy]",
    "First": "[Đầu tiên]",
    "Fist": "[nắm đấm]",
    "Fretting": "[cáu kỉnh]",
    "Frown": "[cau mày]",
    "Funny": "[Cười và khóc]",
    "Ghost": "[Ma quái]",
    "GiveMeFive": "[Bàn tay]",
    "GoodJob": "[Mạnh mẽ]",
    "Grimace": "[nhăn mặt]",
    "Halo": "[Đôi mắt tỏa sáng]",
    "Happy": "[Vui vẻ]",
    "Hi": "[vẫy tay]",
    "Hit": "[Hit you]",
    "Hold": "[Giơ tay lên]",
    "Joy": "[Niềm vui]",
    "Kiss": "[hôn]",
    "Knife": "[kéo]",
    "Laugh": "[Cười]",
    "Low": "[Cấp thấp]",
    "Mad": "[Tức giận]",
    "Mask": "[Mặt nạ]",
    "Mischievous": "[cười gian]",
    "Monkey": "[Khỉ]",
    "Nice": "[Thích]",
    "No": "[Đừng]",
    "NoListen": "[Không nghe]",
    "NoLook": "[Không xem]",
    "NoWords": "[Không nói]",
    "Ok": "[Được rồi]",
    "Pig": "[Đầu heo]",
    "Please": "[A Di Đà Phật]",
    "Poop": "[Phân]",
    "Rocket": "[Tên lửa]",
    "Sexy": "[màu]",
    "Shame": "[Thẹn thùng]",
    "Sleep": "[Đang ngủ]",
    "Sleeping": "[Đang ngủ]",
    "Snicker": "[cười trộm]",
    "Spit": "[lè lưỡi]",
    "Squint": "[nheo mắt]",
    "Surprise": "[ngạc nhiên]",
    "Sweat": "[Đổ mồ hôi]",
    "Tears": "[khóc]",
    "Terrorist": "[Kinh dị]",
    "Think": "[Suy nghĩ]",
    "Thrill": "[hoảng sợ]",
    "Tired": "[Mạo Tinh]",
    "Uncomfortable": "[Khó chịu]",
    "Unhappy": "[Không hài lòng]",
    "acceptFailedText": "Đồng ý rằng ứng dụng thất bại",
    "acceptResultText": "Đã đồng ý",
    "acceptText": "Đồng ý",
    "acceptedText": "Đã đồng ý",
    "accountNotMatchText": "Không tìm thấy tài khoản này",
    "accountPlaceholder": "Vui lòng nhập số tài khoản",
    "accountText": "Số tài khoản",
    "addButtonText": "Thêm",
    "addChatMemberText": "Thêm thành viên trò chuyện",
    "addFailedText": "Lỗi thêm",
    "addFriendFailedText": "Thêm bạn bè thất bại",
    "addFriendMode": "Thêm chế độ bạn bè",
    "addFriendSuccessText": "Thêm bạn bè thành công",
    "addFriendText": "Thêm bạn bè",
    "addMessageTop": "Đặt một tin nhắn.",
    "addStickTopText": "Thông điệp hàng đầu",
    "addSuccessText": "Thêm thành công",
    "addTeamMemberConfirmText": "Vui lòng chọn thành viên nhóm bạn muốn thêm",
    "addTeamMemberFailedText": "Thêm thành viên thất bại",
    "addTeamMemberSuccessText": "Thêm thành viên thành công",
    "addTeamMemberText": "Thêm thành viên",
    "addTeamMemberVerifyText": "Đang chờ xác minh",
    "addressText": "Sổ địa chỉ",
    "aiAntiSpamText": "Yêu cầu chống rác",
    "aiBlockFailedText": "Hoạt động Blacklist trên Digital People không được phép",
    "aiConversationSelectFailed": "Chọn phiên AI thất bại",
    "aiErrorText": "Máy chủ bận, vui lòng thử lại sau",
    "aiFriendNotExists": "Bạn bè không tồn tại",
    "aiFunctionDisabled": "Chức năng nhắn tin AI không mở",
    "aiListTitle": "Con số của tôi",
    "aiMemberBanned": "Người dùng bị vô hiệu hóa",
    "aiMemberChatBanned": "User bị cấm",
    "aiMenuText": "Con số của tôi",
    "aiMessageHitAntiSpam": "Thông điệp chống rác",
    "aiNormalTeamChatBanned": "Thành viên bình thường cấm nói",
    "aiParameterError": "Lỗi tham số",
    "aiProxyFailedText": "Mô hình yêu cầu ngoại lệ",
    "aiRateLimit": "Tần số vượt quá",
    "aiSearchInputPlaceholder": "Nhập thêm thông tin",
    "aiSearchText": "AI tìm kiếm từ",
    "aiSearchingText": "AI đang tìm kiếm. ..",
    "aiSendingText": "Mô hình phản hồi yêu cầu lớn",
    "aiStopFailedText": "Lỗi dừng xuất",
    "aiStreamCancelText": "Yêu cầu bị hủy",
    "aiStreamText": "Đầu ra dòng chảy kỹ thuật số",
    "aiTeamChatBanned": "Thành viên nhóm bị cấm",
    "aiTeamMemberNotExists": "Thành viên nhóm không tồn tại",
    "aiTranslateEmptyText": "Vui lòng nhập nội dung cần dịch",
    "aiTranslatePlaceholder": "Dịch sang. ..",
    "aiTranslateText": "AI xử lý",
    "aiTranslatedText": "Sử dụng",
    "aiTranslatingText": "AI đang xử lý. ..",
    "aiUserText": "Số người",
    "aleadyInTeamText": "Đã vào nhóm",
    "aliasText": "Ghi chú",
    "allReadText": "Tất cả đã đọc",
    "allUnReadText": "Tất cả chưa đọc",
    "amap": "Bản đồ Gauder",
    "applyFriendFailedText": "Yêu cầu thêm bạn bè thất bại",
    "applyFriendSuccessText": "Đăng ký thêm bạn bè thành công",
    "applyFriendText": "Thêm bạn như một người bạn",
    "applyTeamSuccessText": "Đăng ký thành công",
    "applyTeamText": "Đăng ký vào nhóm",
    "audioMsgText": "Tin nhắn âm thanh",
    "bdmap": "Baidu bản đồ",
    "beAddTeamManagersText": "Được bổ nhiệm làm admin",
    "beMentioned": "[Ai đó @ tôi]",
    "beRejectResultText": "Từ chối yêu cầu kết bạn",
    "beRemoveTeamManagersText": "Loại bỏ Admin",
    "beRemoveTeamText": "Được chuyển ra khỏi nhóm",
    "blackFailedText": "Đen thất bại",
    "blackListDesc": "(Bạn sẽ không nhận được tin nhắn từ bất kỳ liên hệ nào trong danh sách)",
    "blackListTitle": "Danh sách đen",
    "blackMenuText": "Danh sách đen",
    "blackSuccessText": "Đen thành công",
    "blackText": "Đen bạn thân",
    "callBusyText": "nhau bận rộn.",
    "callCancelText": "Đã hủy",
    "callDurationText": "Thời lượng cuộc gọi",
    "callFailed": "Cuộc gọi thất bại",
    "callMsgText": "Thông điệp",
    "callRejectedText": "Bị từ chối",
    "callTimeoutText": "Hết giờ",
    "cancelText": "Hủy bỏ",
    "cancelUploadFailedText": "Hủy tải lên không thành công",
    "chatButtonText": "Trò chuyện",
    "chatHistoryText": "Lịch sử trò chuyện",
    "closeAgreeModeText": "Đóng lời mời nhập nhóm cần được đồng ý",
    "closeApplyModeText": "Tắt kiểm tra nhóm",
    "closeText": "Đóng cửa",
    "collection": "Bộ sưu tập",
    "collectionFailed": "Bộ sưu tập thất bại",
    "collectionSuccess": "Bộ sưu tập",
    "collectionText": "Bộ sưu tập",
    "commentText": "Tin nhắn",
    "confirmDeleteFriendText": "Xóa bạn bè?",
    "confirmDeleteText": "Xác định xóa?",
    "confirmRemoveCollection": "Xác nhận xóa bộ sưu tập?",
    "createButtonText": "Tạo",
    "createDiscussionText": "Tạo một nhóm thảo luận",
    "createTeamFailedText": "Lỗi tạo nhóm",
    "createTeamMemberLimitText": "Giới hạn số lượng nhóm",
    "createTeamSuccessText": "Tạo nhóm thành công",
    "createTeamText": "Tạo nhóm",
    "customMsgText": "Tin nhắn tùy chỉnh",
    "deleteFriendFailedText": "Xóa bạn bè thất bại",
    "deleteFriendSuccessText": "Xóa bạn bè thành công",
    "deleteFriendText": "Xóa bạn bè",
    "deleteSessionText": "Xoá phiên chạy",
    "deleteStickTopText": "Hủy bỏ top",
    "deleteText": "Xoá",
    "discussionAvatarText": "Thảo luận nhóm Avatar",
    "discussionDoNotDisturbText": "Nhóm thảo luận Miễn làm phiền",
    "discussionIdText": "Thảo luận Group ID",
    "discussionMemberText": "Thành viên nhóm thảo luận",
    "discussionText": "Thông tin nhóm thảo luận",
    "discussionTitle": "Tên nhóm thảo luận",
    "dismissTeamConfirmText": "Xác nhận giải tán nhóm",
    "dismissTeamFailedText": "Giải tán nhóm thất bại",
    "dismissTeamSuccessText": "Giải tán nhóm thành công",
    "dismissTeamText": "Giải tán nhóm",
    "editNickInTeamText": "Biên tập biệt danh của tôi trong nhóm",
    "emailErrorText": "Định dạng hộp thư không chính xác",
    "emailPlaceholder": "Vui lòng nhập hộp thư",
    "emailText": "Hộp thư",
    "enText": "English",
    "enableV2CloudConversationText": "Mở Cloud Session",
    "enterTeamText": "Vào nhóm.",
    "expiredResultText": "Hết hạn",
    "fileMsgText": "Thông điệp tập tin",
    "forwardFailedText": "Chuyển tiếp thất bại",
    "forwardSuccessText": "Chuyển tiếp thành công",
    "forwardText": "Chuyển tiếp",
    "friendListTitle": "Bạn tốt của tôi",
    "friendMenuText": "Bạn tốt của tôi",
    "friendText": "Bạn thân",
    "genderPlaceholder": "Vui lòng chọn giới tính",
    "genderText": "Giới tính",
    "geoMsgShortText": "Địa điểm",
    "geoMsgText": "Thông báo vị trí địa lý",
    "getApplyMsgFailedText": "Lỗi lấy tin nhắn",
    "getCollectionFailed": "Truy vấn danh sách bộ sưu tập không thành công",
    "getHistoryMsgFailedText": "Lỗi lấy tin nhắn lịch sử",
    "getRelationFailedText": "Mối quan hệ thất bại",
    "huff": "[Tức giận]",
    "ill": "[Không thoải mái]",
    "imgMsgText": "Thông điệp hình ảnh",
    "imgText": "Hình ảnh",
    "inCallText": "Đang gọi, vui lòng gọi lại sau khi kết thúc cuộc gọi",
    "inviteTeamText": "Mời bạn tham gia",
    "inviteText": "Thư mời",
    "joinTeamFailedText": "Gia nhập nhóm thất bại",
    "joinTeamSuccessText": "Tham gia nhóm thành công",
    "joinTeamText": "Tham gia nhóm",
    "joinTeamWithVerifyText": "Yêu cầu gia nhập nhóm đã được gửi",
    "languageText": "Ngôn ngữ",
    "leaveDiscussionButtonText": "Thoát khỏi nhóm thảo luận",
    "leaveDiscussionConfirmText": "Xác nhận rút khỏi nhóm thảo luận",
    "leaveDiscussionFailedText": "Thoát khỏi nhóm thảo luận này không thành công",
    "leaveDiscussionSuccessText": "Đã thoát khỏi nhóm thảo luận này thành công",
    "leaveDiscussionText": "Rời khỏi nhóm thảo luận",
    "leaveDiscussionTitle": "Thoát khỏi nhóm thảo luận",
    "leaveTeamButtonText": "Xóa và thoát",
    "leaveTeamConfirmText": "Xác nhận thoát khỏi nhóm",
    "leaveTeamFailedText": "Thoát khỏi nhóm này thất bại",
    "leaveTeamSuccessText": "Đã thoát khỏi nhóm này thành công",
    "leaveTeamText": "Rời khỏi nhóm",
    "leaveTeamTitle": "Rời khỏi nhóm",
    "logoutConfirmText": "Bạn có chắc chắn để thoát khỏi Login?",
    "logoutText": "Đăng nhập",
    "man": "Nam",
    "maxSelectedText": "Nhiều nhất chỉ có thể chọn",
    "memberNotExistsText": "Người dùng không tồn tại",
    "msgListTitle": "Trung tâm thông điệp",
    "msgMenuText": "Trung tâm thông điệp",
    "msgRecallTimeErrorText": "Đã quá thời gian không thể rút lại",
    "muteAllTeamFailedText": "Mở khóa cấm ngôn thất bại",
    "muteAllTeamSuccessText": "Mở khóa toàn bộ cấm ngôn thành công",
    "muteSessionText": "Mở Không làm phiền",
    "needBeInvitedText": "Cần có sự đồng ý của người mời",
    "needMentionText": "Cần",
    "needVerifyText": "Cần xác minh",
    "networkDisconnectText": "Kết nối mạng bị ngắt kết nối, vui lòng kiểm tra cài đặt mạng của bạn và thử kết nối lại",
    "newGroupOwnerText": "Trở thành chủ nhóm mới",
    "nickInTeamText": "Biệt danh của tôi trong nhóm",
    "nickPlaceholder": "Vui lòng nhập nickname",
    "nickText": "Biệt danh",
    "noMoreCollectionText": "Đã trượt xuống đáy~",
    "noMoreText": "Không còn tin tức gì nữa.",
    "noPermission": "Anh không được phép hoạt động.",
    "noText": "Không",
    "notAnAi": "Không phải tài khoản Digital Man",
    "notNeedBeInvitedText": "Không cần sự đồng ý của người mời",
    "notNeedVerifyText": "Không cần xác minh",
    "notSupportJoinText": "Nhóm thảo luận không thể tham gia trực tiếp, vui lòng liên hệ với quản trị viên để kéo bạn vào nhóm",
    "notSupportMessageText": "Không ủng hộ thông điệp này",
    "notiMsgText": "Thông báo",
    "offlineText": "(ngoại tuyến)",
    "ok": "[OK]",
    "okText": "Xác định",
    "onDismissDiscussionText": "Nhóm thảo luận bị giải tán",
    "onDismissTeamText": "Nhóm đã bị giải tán.",
    "onRemoveTeamText": "Bạn đã được chuyển ra khỏi nhóm",
    "onlineText": "(Trực tuyến)",
    "onlyTeamOwner": "Chỉ chủ nhóm",
    "openAgreeModeText": "Mở thư mời nhập nhóm cần đồng ý",
    "openApplyModeText": "Bắt đầu xét duyệt nhóm.",
    "openText": "Mở",
    "oppositeSide": "Đối phương",
    "p2pMsgVisibleModeText": "Hiển thị tin nhắn p2p đã đọc chưa đọc",
    "passFriendAskText": "Tôi đã đồng ý với yêu cầu của bạn, bây giờ hãy bắt đầu trò chuyện.",
    "passResultText": "Thông qua yêu cầu kết bạn",
    "personUnit": "Người",
    "phonePlaceholder": "Vui lòng nhập số điện thoại",
    "phoneText": "Điện thoại",
    "pinAIText": "Pin lên đỉnh",
    "processedValidationMessageText": "Thông điệp xác minh này đã được xử lý",
    "readText": "Đã đọc",
    "recallMessageText": "Rút tin nhắn",
    "recallReplyMessageText": "Tin nhắn đã bị thu hồi hoặc xóa",
    "recallText": "Rút tiền",
    "receiveText": "Bạn nhận được tin nhắn mới",
    "recentConversationText": "Phiên gần đây",
    "recentForwardText": "Chuyển tiếp gần đây",
    "recentSessionText": "Truy cập gần đây",
    "reeditText": "Sửa lại",
    "regenAIMsgFailedText": "Tái tạo thất bại",
    "rejectFailedText": "Từ chối yêu cầu thất bại",
    "rejectResultText": "Bị từ chối",
    "rejectTeamFailedText": "Ứng dụng từ chối nhóm thất bại",
    "rejectTeamInviteText": "Từ chối lời mời nhóm",
    "rejectText": "Từ chối",
    "rejectedTeamText": "Yêu cầu nhóm bị từ chối",
    "rejectedText": "Ứng dụng đã bị từ chối",
    "removeBlackFailedText": "Xóa sổ đen thất bại",
    "removeBlackSuccessText": "Xóa đen thành công",
    "removeBlackText": "Gỡ bỏ Black",
    "removeCollectionFailed": "Lỗi xóa bộ sưu tập",
    "removeCollectionSuccess": "Xóa bộ sưu tập thành công",
    "removeMessageTop": "Xóa tin nhắn hàng đầu",
    "removeTeamMemberConfirmText": "Xác nhận loại bỏ thành viên?",
    "removeTeamMemberFailedText": "Xóa thành viên thất bại",
    "removeTeamMemberSuccessText": "Xóa thành viên thành công",
    "removeTeamMemberText": "Xóa thành viên",
    "replyText": "Trả lời",
    "robotMsgText": "Thông điệp máy",
    "saveFailedText": "Lỗi lưu",
    "saveSuccessText": "Lưu thành công",
    "saveText": "Lưu",
    "sdkVersionSelectionText": "Lựa chọn phiên bản SDK",
    "searchButtonText": "Tìm kiếm",
    "searchDiscussionMemberPlaceholder": "Tìm kiếm thành viên nhóm thảo luận",
    "searchDiscussionTitle": "Nhóm thảo luận",
    "searchEmptyText": "Bạn chưa thêm bạn bè và nhóm",
    "searchFriendTitle": "Bạn thân",
    "searchInputPlaceholder": "Tìm kiếm",
    "searchNoResText": "Không có kết quả tìm kiếm",
    "searchTeamMemberPlaceholder": "Tìm kiếm thành viên nhóm",
    "searchTeamPlaceholder": "Vui lòng nhập tên nhóm",
    "searchTeamTitle": "Nhóm",
    "searchText": "Tìm kiếm",
    "searchTipText": "Enter tìm kiếm",
    "securityTipText": "Chỉ dùng để trải nghiệm chức năng sản phẩm IBM của Vân Tín, xin đừng dễ tin các thông tin liên quan đến tiền như gửi tiền, trúng thưởng, v. v., đừng dễ dàng gọi điện thoại xa lạ, đề phòng bị lừa gạt.",
    "selectedText": "Đã chọn",
    "sendBlackFailedText": "Anh đã bị kéo vào danh sách đen.",
    "sendBtnText": "Gửi",
    "sendEmptyText": "Không thể gửi tin nhắn trống",
    "sendMsgFailedText": "Gửi tin nhắn thất bại",
    "sendNotFriendFailedText": "Không kết bạn hiện tại",
    "sendText": "Gửi tin nhắn",
    "sendToText": "Gửi tới",
    "sendUsageText": "(Nhấn Enter để gửi trực tiếp, Shift+Enter để chuyển dòng)",
    "session": "Phiên chạy",
    "setText": "Thiết lập",
    "settingText": "Thiết lập",
    "signPlaceholder": "Vui lòng nhập chữ ký",
    "signText": "Chữ ký",
    "strangerNotiText": "Hiện tại không phải là bạn của bạn, xin chú ý bảo vệ an toàn riêng tư cá nhân.",
    "strangerText": "Người lạ",
    "teamAgreeModeExplainText": "Sau khi bật, các thành viên cần có sự đồng ý của chủ nhóm hoặc quản trị viên để gia nhập nhóm.",
    "teamAgreeModeText": "Kiểm toán nhóm",
    "teamAll": "Tất cả",
    "teamAtModeText": "Ai có thể @ mọi người",
    "teamAvatarConfirmText": "Đầu nhóm không thể rỗng",
    "teamAvatarText": "Đầu nhóm",
    "teamDoNotDisturbText": "Nhóm miễn làm phiền",
    "teamIdNotMatchText": "Không tìm thấy số nhóm này",
    "teamIdPlaceholder": "Vui lòng nhập ID nhóm",
    "teamIdText": "ID nhóm",
    "teamInfoText": "Thông tin nhóm",
    "teamInviteModeText": "Ai có thể mời thành viên mới",
    "teamJoinModeExplainText": "Sau khi mở, kéo vào nhóm, cần được người mời đồng ý.",
    "teamJoinModeFreeText": "Tự do tham gia, không cần xác minh",
    "teamJoinModeNeedVerifyText": "Yêu cầu đăng ký, chủ nhóm hoặc quản lý đồng ý tham gia",
    "teamJoinModeText": "Lời mời nhập nhóm cần được đồng ý",
    "teamListTitle": "Nhóm của tôi",
    "teamManagerEditText": "Quản lý nhân sự",
    "teamManagerEmptyText": "Không có quản lý nhóm",
    "teamManagerEnableText": "Mở chức năng quản trị nhóm",
    "teamManagerLimitText": "Ai có thể thay đổi thông tin",
    "teamManagerText": "Quản trị nhóm",
    "teamMemberLimitText": "Số lượng thành viên nhóm đã đạt đến giới hạn",
    "teamMemberNotExist": "Trò chuyện nhóm không còn tồn tại",
    "teamMemberText": "Thành viên nhóm",
    "teamMenuText": "Nhóm của tôi",
    "teamMsgVisibleModeText": "Hiển thị tin nhắn nhóm đã đọc chưa đọc",
    "teamMutePlaceholder": "Trong nhóm chat hiện tại",
    "teamMuteText": "Nhóm cấm ngôn",
    "teamNotExitsText": "Nhóm không tồn tại",
    "teamOwnerAndManagerText": "Chủ nhóm và quản trị viên",
    "teamOwnerText": "Trang chủ",
    "teamPowerText": "Quản lý nhóm",
    "teamSignPlaceholder": "Vui lòng nhập nội dung",
    "teamSignText": "Giới thiệu nhóm",
    "teamTitle": "Tên nhóm",
    "teamTitleConfirmText": "Tên nhóm không thể rỗng",
    "teamTitlePlaceholder": "Vui lòng nhập tên nhóm",
    "teamTopModeText": "Ai có thể cập nhật tin tức",
    "textMsgText": "Tin nhắn văn bản",
    "tipAIFailedMessageText": "Yêu cầu mô hình ngôn ngữ lớn không thành công",
    "tipAIMessageText": "Định dạng không được hỗ trợ",
    "tipMsgText": "Tin nhắn",
    "topFailedText": "Lên đỉnh thất bại",
    "topText": "Đặt đỉnh",
    "transferOwnerConfirmText": "Xác nhận chuyển nhượng nhóm",
    "transferOwnerText": "Chuyển chủ nhóm",
    "transferTeamFailedText": "Chuyển chủ nhóm thất bại",
    "transferTeamSuccessText": "Chuyển chủ nhóm thành công",
    "transferToText": "Chuyển nhượng",
    "txmap": "Bản đồ Tencent",
    "unTopText": "Hủy bỏ top",
    "unknow": "Không rõ",
    "unknowMsgText": "Thông điệp không rõ",
    "unmuteAllTeamFailedText": "Kết thúc cấm ngôn thất bại",
    "unmuteAllTeamSuccessText": "Kết thúc cấm đoán thành công",
    "unmuteSessionText": "Hủy bỏ làm phiền miễn phí",
    "unreadText": "Chưa đọc",
    "updateAliasFailedText": "Sửa đổi ghi chú không thành công",
    "updateAliasSuccessText": "Thay đổi ghi chú thành công",
    "updateAllowAt": "Cập nhật \"@ permission\" cho",
    "updateAllowTop": "Cập nhật quyền truy cập tin nhắn hàng đầu",
    "updateBitConfigMaskFailed": "Cập nhật tin nhắn nhóm không làm phiền thất bại",
    "updateBitConfigMaskSuccess": "Cập nhật tin nhắn nhóm Miễn làm phiền thành công",
    "updateMyMemberNickFailed": "Cập nhật nickname nhóm của tôi thất bại",
    "updateMyMemberNickSuccess": "Cập nhật nickname nhóm thành công",
    "updateTeamAvatar": "Update ảnh nhóm",
    "updateTeamFailedText": "Sửa đổi thất bại",
    "updateTeamIntro": "Update giới thiệu nhóm",
    "updateTeamInviteMode": "Cập nhật quyền nhóm \"quyền mời người khác\" như",
    "updateTeamManagerFailText": "Sửa đổi quản trị nhóm thất bại",
    "updateTeamManagerSuccessText": "Chỉnh sửa Group Administrator thành công",
    "updateTeamMute": "Cập nhật \"Cấm ngôn nhóm\".",
    "updateTeamName": "Update tên nhóm là",
    "updateTeamSuccessText": "Sửa đổi thành công",
    "updateTeamUpdateTeamMode": "Cập nhật quyền nhóm \"Quyền thay đổi dữ liệu nhóm\" thành",
    "uploadImgFailedText": "Tải ảnh lên không thành công",
    "uploadLimitText": "Hình ảnh video hoặc kích thước tập tin Hỗ trợ tối đa",
    "uploadLimitUnit": "M",
    "userNotInTeam": "Thành viên không còn trong nhóm",
    "vedioCallText": "Cuộc gọi video",
    "verifyMsgNotExitsText": "Thông điệp xác minh này đã được xử lý",
    "videoMsgText": "Tin nhắn video",
    "videoText": "Việt",
    "voiceCallText": "Cuộc gọi thoại",
    "voiceToText": "Giọng nói sang văn bản",
    "voiceToTextFailedText": "Chuyển văn bản thất bại",
    "welcomeText": "Chào mừng đến với Cloud Letter",
    "woman": "Phụ nữ",
    "yesText": "Vâng",
    "you": "Ngươi",
    "zhText": "Trung Quốc"
}

export default LocaleConfig
